export default {
  title: 'Nebula buds AI Samtale', // "Nebula buds AI通话" 翻译为挪威语
  userID: 'Bruker ID : ', // "用户ID : "
  hurryUp: 'Venter på anrop fra den andre parten', // "等待对方呼叫"
  waitingCall: 'Venter på anrop fra den andre parten på denne siden, vennligst ikke lukk siden for tidlig.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Undertekstbryter', // "字幕开关"
  initWait: 'Venter på initiering', // "等待初始化"
  initSuccess: 'Initiering fullført, venter på anrop fra den andre parten. Vennligst ikke lukk siden!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Samtale koblet', // "电话接通"
  callEnd: 'Samtale avsluttet', // "通话结束"
  careful: 'Vær oppmerksom : ', // "注意 : "
  wait: 'Samtalekomponent er klar, venter på anrop fra den andre parten', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabisk', // "阿拉伯语"
    da: 'Dansk', // "丹麦语"
    de: 'Tysk', // "德语"
    en: 'Engelsk', // "英语"
    es: 'Spansk', // "西班牙语"
    fil: 'Filippinsk', // "菲律宾语"
    fr: 'Fransk', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesisk', // "印度尼西亚语"
    it: 'Italiensk', // "意大利语"
    ja: 'Japansk', // "日文"
    ko: 'Koreansk', // "韩语"
    ms: 'Malaysisk', // "马来语"
    no: 'Norsk', // "挪威语"
    pt: 'Portugisisk', // "葡萄牙语"
    ru: 'Russisk', // "俄语"
    sv: 'Svensk', // "瑞典语"
    th: 'Thai', // "泰语"
    tr: 'Tyrkisk', // "土耳其语"
    vi: 'Vietnamesisk', // "越南语"
    zh: 'Kinesisk' // "中文"
  }
}
